import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo1 from "./assets/logo1.png";

function Navbar() {
  const location = useLocation();
  // Determine if the current page is the SetPassword page
  const isSetPasswordPage = location.pathname.startsWith("/set-password");

  return (
    <div>
      <nav className="navbar navbar-expand-lg landnav">
        <div className="container-fluid">
          <Link className="navbar-brand text-white" to="/">
            <img src={logo1} alt="logo" className="logo1" />
            <span className="ms-2 web-name">Screenify</span>{" "}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon landnav-toggler"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {/* Conditionally render the Sign Up link */}
              {!isSetPasswordPage && (
                <li className="nav-item">
                  <Link className="nav-link land" to="/signup">
                    Sign Up
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
